import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-button", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsButton;
